
import React from "react";

import { connect } from 'react-redux';
import {deleteWeekPlan} from '../actions/index'

import { Line, Bar } from "react-chartjs-2";
import {dataTrainingLoadProjectionPlan} from 'variables/chartsData';
import {optionsTrainingLoad} from 'variables/chartsData';
import { optionProgram ,dataProgram } from "variables/chartsData"
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';


// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Progress,
  Jumbotron,
} from "reactstrap";

import NotificationAlert from "react-notification-alert";

import {runningIndexList} from '../helperFunctions/RunningIndex'
import {runningIndexMedian} from '../helperFunctions/RunningIndex'
import {resampleTssMy3,resampleTssMyProj} from '../helperFunctions/Resample';
import {fitFatForm, tssList} from '../helperFunctions/trainingLoadFunctions'

import CreateNewWeekPlanner from '../components/moreComponents/CreateNewWeekPlanner'
import WeekPlanner from '../components/moreComponents/WeekPlanner';

import TrainingLoadProjectionHelp from '../components/moreComponents/TrainingLoadProjectionHelp'

import {trimpTss,createDataZones,goalAerobicSpeedProgress,goalDistanceProgress,goalMaxSpeedProgress} from '../helperFunctions/PlannerFunctions'



var moment = require('moment')

class Planner extends React.Component {
  
  state ={sliderValue:80}
  changeRange = (value) =>{
    this.setState({sliderValue:value})
  }
  notify(place,message) {
    if (!message){
      return ""
    }
    var color = message[0];
    if (color === "logout"){
      localStorage.clear()
      window.location.replace("/login")
    }
    var type;
    switch (color) {
      case 'success':
        type = "success";
        break;
      case 'danger':
        type = "danger";
        break;
      case 'warning':
        type = "warning";
      default:
        break;
    }
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div style={{height:'70px'}}>
            {message[1]}
          </div>
          
        </div>
      ),
      type: type,
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 10,
    };
    if(this.refs.notificationAlert){
      this.refs.notificationAlert.notificationAlert(options);
    }
  }
  
  deleteItem = (target) =>{
    console.log(target)
    this.props.deleteWeekPlan(target.id)
  } 
  componentDidUpdate(prevProps){
    if(prevProps.message.message !== this.props.message.message && this.props.message.message){
        this.notify("br",this.props.message.message)
    }
  }
  render() {
    if(!Array.isArray(this.props.activities.entries)){
      return(<div></div>)
    }
    //calculate running index
    const activitiesSorted = this.props.activities.entries?.sort((a, b) =>new Date(a.date) -new Date(b.date));
    //const [runningIndex,dates]=runningIndexList(activitiesSorted)
    const [runningIndexMedianList,maxMedian,maxIndex] = runningIndexMedian(activitiesSorted)
    const currentIndex = runningIndexMedianList[runningIndexMedianList.length-1]

    /// calculate trainingLoad
    //const targetForm = this.props.runningProgram.targetForm
    const [tss,datesTss] = tssList(activitiesSorted)
    //console.log("tss",tss)
    const [resampledDates, resampledTss] = resampleTssMy3(datesTss,tss)
    //console.log(resampledTss)
    const [fitness,fatigue,form] = fitFatForm(resampledDates, resampledTss)
    const currentFitness = fitness[fitness.length-61]
    const currentFatigue = fatigue[fatigue.length-61]
    const currentForm = form[form.length-61]
    //console.log(fitness,fatigue,form,"nenenenen")
    localStorage.setItem('fitness',currentFitness)
    localStorage.setItem('fatigue',currentFatigue)
    localStorage.setItem('form',currentForm)
    
    
    
    if(this.props.plan.entries.length<1){
      
      
        return (
          <div>
               <CardTitle tag="h4" style={{marginLeft:"20px",color:'rgb(240,240,240)'}}>Custom Planner</CardTitle>
                    <p className="category" style={{marginLeft:"20px",color:'rgb(240,240,240)'}}>No running program in progress</p>
              <Row style={{marginTop:'50px'}}>
                <Col xs={12} md={4}>
                
                </Col>
                <Col xs={12} md={4}>
                <Col xs={12} md={8}>
                  <CreateNewWeekPlanner user={this.props.auth} mode='Create'/>
                </Col>
                </Col>
                <Col xs={12} md={4}>
                
                </Col>
            
              </Row></div>
        )
      
      }
      
    
    /// Calculate running program
    localStorage.setItem('runningIndex',currentIndex)
    localStorage.setItem('fitness',currentFitness)
    localStorage.setItem('fatigue',currentFatigue)
    localStorage.setItem('form',currentForm)
    
    
    
   

    // Projected chart 
    const chartColor = "#1ebfe8";
    const gradientFill = 'rgba(255, 255, 200, 0.1)';
    
    
    //console.log(weeks)
    //console.log(tssProjectedList)
    
    var programStartIndex = -1
    for (var i=0;i<datesTss.length;i++){
      
      if(moment(datesTss[i]).isAfter(moment())){
        programStartIndex = i
        console.log(programStartIndex)
        break
      }
    }
    var datesTssSliced = datesTss.slice(0,programStartIndex)
    var tssSliced = tss.slice(0,programStartIndex)

    
    var data = dataTrainingLoadProjectionPlan([0,0,0],[0,0,0],[0,0,0],[0,0,0],"chartColor","chartColor",[0,100],"chartColor")
    
    var options = optionsTrainingLoad()

    var weeksPlan = []
    
    if(this.props.plan.entries.length>0){
      var weeksPlan = this.props.plan.entries
      var startingProjectDate = moment(weeksPlan[0].date)
      var endingDate = moment(weeksPlan[weeksPlan.length-1].date).add(1,'week')
      //console.log(startingProjectDate,endingDate,weeksPlan)
    
      var tssListProjection = []
      var dateListProjection = []
      
      for (var i=0;i<weeksPlan.length;i++){
        for(var j=0;j<7;j++){
          if (j==0 ){
            dateListProjection.push(moment(weeksPlan[i].date).add(0,'day'))
          }
          else{
            dateListProjection.push(moment(weeksPlan[i].date).add(j,'day'))
          }
         
          
          
        }
        tssListProjection.push(trimpTss(weeksPlan[i].monday,this.props.auth)[0])
        tssListProjection.push(trimpTss(weeksPlan[i].tuesday,this.props.auth)[0])
        tssListProjection.push(trimpTss(weeksPlan[i].wednesday,this.props.auth)[0])
        tssListProjection.push(trimpTss(weeksPlan[i].thursday,this.props.auth)[0])
        tssListProjection.push(trimpTss(weeksPlan[i].friday,this.props.auth)[0])
        tssListProjection.push(trimpTss(weeksPlan[i].saturday,this.props.auth)[0])
        tssListProjection.push(trimpTss(weeksPlan[i].sunday,this.props.auth)[0])
        
      }
      var projectStartIndex = 0
      for(var i=0;i<dateListProjection.length;i++){
        if(moment(dateListProjection).isSame(moment())){
          tssListProjection[i] = 0
        }
        if(moment(dateListProjection[i]).isAfter(moment())){
          
          
          break
        }
        else{
          tssListProjection[i] = 0
        }
      }
      
      console.log(datesTssSliced,dateListProjection,tssListProjection)
      const [resampledDatesProj, resampledTssProj] = resampleTssMyProj(datesTssSliced.concat(dateListProjection),tssSliced.concat(tssListProjection))
    const [fitnessProj,fatigueProj,formProj] = fitFatForm(resampledDatesProj, resampledTssProj)
    var sliceOfChart = 80
    if (datesTss.length<100){
      sliceOfChart = 30
    }
    if (datesTss.length<50){
      sliceOfChart = 0
    }
    
    
    data = dataTrainingLoadProjectionPlan(resampledDatesProj,fitnessProj,fatigueProj,formProj,chartColor,gradientFill,[this.state.sliderValue,100],moment())
    const max = Math.max.apply(null, fatigueProj)
    //console.log(resampledDatesProj,fitnessProj,fatigueProj,formProj)
    options = optionsTrainingLoad(max)
    }


    // Zones //
    var dataZones = [0,0,0,0,0,0]
    for (var i=0;i<weeksPlan.length;i++){
      dataZones = createDataZones(weeksPlan[i].monday,dataZones,this.props.auth)
      dataZones = createDataZones(weeksPlan[i].tuesday,dataZones,this.props.auth)
      dataZones = createDataZones(weeksPlan[i].wednesday,dataZones,this.props.auth)
      dataZones = createDataZones(weeksPlan[i].thursday,dataZones,this.props.auth)
      dataZones = createDataZones(weeksPlan[i].friday,dataZones,this.props.auth)
      dataZones = createDataZones(weeksPlan[i].saturday,dataZones,this.props.auth)
      dataZones = createDataZones(weeksPlan[i].sunday,dataZones,this.props.auth)
      
    }
    //console.log(dataZones)
    
    var dataZonesGraph = dataProgram(dataZones)
    var optionsZonesGraph = optionProgram()

    var goalAerobicSpeed = goalAerobicSpeedProgress(dataZones)
    var goalDistance = goalDistanceProgress(dataZones)
    var goalMaxSpeed = goalMaxSpeedProgress(dataZones)
    
    console.log(weeksPlan[0])
    return (
      <>
        <div className="content" style={{marginTop:"25px",color:"white",fontSize:'12px'}}>
        <NotificationAlert ref="notificationAlert" />
          <Row>
            <Col xs={12}>
              <Card className="card-plain">
                <CardHeader>
                  <CardTitle tag="h4">Custom Planner </CardTitle>
                  <CardTitle tag="h4">Work in progress </CardTitle>
                  <p className="category"></p>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col xs={12} md={4}>
                        
                        </Col>
                        <Col xs={12} md={4}>
                            <CreateNewWeekPlanner user={this.props.auth} mode={'Create'}/>
                        </Col>
                        <Col xs={12} md={4}>
                        
                        </Col>
                    
                    </Row>
                  <Table responsive>
                    <thead className="text-primary">
                      <tr>
                         <th>
                             Monday
                         </th>
                         <th>
                             Tuesday
                         </th>
                         <th>
                             Wednesday
                         </th>
                         <th>
                             Thursday
                         </th>
                         <th>
                             Friday
                         </th>
                         <th>
                             Saturday
                         </th>
                         <th>
                             Sunday
                         </th>
                         <th>
                             Summary
                         </th>
                      </tr>
                    </thead>
                  </Table>  
                    {weeksPlan.map((week,key) =>{
                      
                      return(
                        <>
                        <Table responsive>
                        <WeekPlanner   key={key} week={week} measurementSystem={this.props.auth.measurementSystem}/>
                        </Table>
                        
                        <Row>
                          <Col xs={3} md={4}>
                            
                          </Col>
                          <Col xs={4} md={2}>
                            <Button id={week.id} onClick={(e)=>this.deleteItem(e.target)} className="btn-danger">Delete</Button>
                          </Col>
                          <Col xs={4} md={2}>
                            <CreateNewWeekPlanner id={week.id} style={{marginTop:'15px'}} user={this.props.auth} week={week} mode={'Edit'}/>
                          </Col>
                          <Col xs={3} md={4}>
                            
                          </Col>
                        </Row>
                        
                        
                        <Row>
                          <hr></hr>
                          
                        </Row>
                        </>
                      )
                      
                       
                    })}
                    
                  
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row style={{padding:'30px'}}>
            <Col lg={12}>
              <div>
                <Jumbotron className='text-info' style={{backgroundColor:'rgb(30,30,30)'}}>
                  
                  <p className="lead"></p>
                  <p className="lead">
                    
                    <Bar
                        data={dataZonesGraph}
                        options={optionsZonesGraph}
                      />
                    
                  </p>
                  
                  <h3 style={{color:"rgb(240,240,240"}}>Training goal</h3>
                  <label style={{fontSize:'13px',color:'rgb(100,200,255)'}}>Increase Distance </label>
                  <Progress color="info" value={goalDistance} style={{height:'3px'}}/>
                  <label style={{fontSize:'13px',color:'rgb(100,200,255)'}}>Increase Aerobic Speed and Capacity </label>
                  <Progress color="success" value={goalAerobicSpeed} style={{height:'3px'}}/>
                  <label style={{fontSize:'13px',color:'rgb(100,200,255)'}}>Increase Threshold/Max Speed </label>
                  <Progress color="danger" value={goalMaxSpeed} style={{height:'3px'}}/>
                  <hr className="my-2" />
                  
                  
                  
                  

                
                  
                 
                </Jumbotron>
              </div>
              </Col>
            </Row>
          <Row>
            
            <Col xs={12} md={12}>
              <Card className="card-chart" style={{backgroundColor: 'rgb(38,38,38)',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category"></h5>
                  <CardTitle tag="h4"></CardTitle>
                    <h3 className='text-warning'>Training Load Projection <TrainingLoadProjectionHelp/></h3>
                    <Row>
                      <Col xs={12} md={12}>
                        <Line
                          data={data}
                          options={options}
                          height='350px'
                        />
                      
                      </Col>
                      
                      
                    </Row>
                    <Slider  min={0}  max={100} value={this.state.sliderValue} step={1} onChange={this.changeRange}/> 
                </CardHeader>    
              </Card>
            </Col>
                
            <Col xs={12} md={4}>
              
            </Col>
          </Row>
          
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) =>{
  
  return {activities:state.activities,runningProgram:state.runningProgram,message:state.message,auth:state.auth,plan:state.plan}
}


export default connect(mapStateToProps,{deleteWeekPlan})(Planner);
